"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskSVGDraw = void 0;
const mithril_1 = require("../mithril");
const theme_1 = require("../theme");
class MaskSVGDraw {
    static view(node, options) {
        var _a;
        if (!options.isInsightMaskVisible) {
            options.draw.log.debug({
                drawable: node.id,
                visibleInsightMasks: options.draw.state.visibleInsightMasks,
            }, 'Masks not rendered because isInsightMaskVisible is false. This is normal when the mask button is disabled. If the mask button is enabled, check the "feature.insight.ahoa" token is enabled, user is IKE Analyst, and that the mask drawable has a parsed SVG.');
            return null;
        }
        if (!options.insightMaskTypesVisible) {
            options.draw.log.warn({ drawable: node.id }, 'Masks not rendered because insightMaskTypesVisible is false. Check the "feature.insight.ahoa" token is enabled, and that the user is IKE Analyst.');
            return null;
        }
        const svgGroups = node.getVisibleSvgDetectionGroups((_a = options.insightMaskTypesVisible) !== null && _a !== void 0 ? _a : [], options.draw.log);
        if (!svgGroups) {
            return null;
        }
        // Assume one group for each object type
        const detectionClassGroups = options.insightMaskTypesVisible.map((detectionClass) => {
            return svgGroups.find((g) => g.id === detectionClass);
        });
        //TODO: need to sort each shape by y position
        const detectionClassGroupShapes = detectionClassGroups
            .filter(Boolean)
            .map((group) => {
            if (!group) {
                return null;
            }
            return group.g.map((item) => {
                return getShapes(item, group.id);
            });
        })
            .filter(Boolean);
        if (!detectionClassGroupShapes.length) {
            options.draw.log.warn({
                detectionClassGroups,
                detectionClassGroupShapes,
            }, 'Masks SVG contained detection groups but none of them contained detection shapes');
        }
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.mask,
            id: `mask-${node.id}`,
        }, [detectionClassGroupShapes]);
    }
}
exports.MaskSVGDraw = MaskSVGDraw;
function getShapes(item, type) {
    var _a, _b, _c, _d;
    const polylineNode = item.polyline
        ? (0, mithril_1.m)('polyline', {
            id: (_a = item.polyline) === null || _a === void 0 ? void 0 : _a.id,
            points: (_b = item.polyline) === null || _b === void 0 ? void 0 : _b.points,
            style: {
                'pointer-events': 'none',
            },
        })
        : null;
    const pathNode = item.path
        ? (0, mithril_1.m)('path', {
            id: (_c = item.path) === null || _c === void 0 ? void 0 : _c.id,
            d: (_d = item.path) === null || _d === void 0 ? void 0 : _d.d,
            style: {
                'pointer-events': 'none',
            },
        })
        : null;
    if (!polylineNode && !pathNode) {
        return null;
    }
    return (0, mithril_1.m)('g', {
        className: type,
        id: item.id,
    }, [polylineNode, pathNode]);
}
//# sourceMappingURL=mask.draw.svg.js.map